import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import "./SegmAnnoLabelDetail.css";

const SegmAnnoLabelDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [label, setLabel] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/patients/segm_anno_labels/${id}/`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => {
        setLabel(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Error fetching SegmAnno Label detail");
        setLoading(false);
      });
  }, [id, token]);

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete this SegmAnno label?")) {
      axios
        .delete(`${process.env.REACT_APP_BACKEND_URL}/patients/segm_anno_labels/${id}/delete/`, {
          headers: { Authorization: `Token ${token}` },
        })
        .then(() => {
          navigate("/segm_anno_labels");
        })
        .catch((err) => {
          alert("Error deleting SegmAnno label");
        });
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="error-message">{error}</p>;
  if (!label) return <p>No SegmAnno Label found.</p>;

  return (
    <div className="segm-anno-label-detail-container">
      <h3>SegmAnno Label Detail</h3>
      <p>
        <strong>ID:</strong> {label.id}
      </p>
      <p>
        <strong>Content Type:</strong> 
        <Link style={{ textDecoration: "none" }} to={`/${label.foreign_key.modality}s/`}>
          {label.foreign_key.modality.toUpperCase()}
        </Link>
      </p>
      <p>
        <strong>Object ID:</strong>
        <Link style={{ textDecoration: "none" }} to={`/${label.foreign_key.modality}s/${label.foreign_key.id}`}>
          {label.foreign_key.id}
        </Link>
      </p>
      <p>
        <strong>File Path:</strong> {label.file_path}
      </p>
      <p>
        <strong>Frame Index:</strong> {label.frame_index}
      </p>
      <p>
        <strong>Datasets:</strong> {label.datasets.join(", ")}
      </p>
      <p>
        <strong>Annotator:</strong> {label.annotator}
      </p>
      <p>
        <strong>Cardiac Phase:</strong> {label.cardiac_phase}
      </p>
      <p>
        <strong>Uploader:</strong> {label.uploader}
      </p>
      <p>
        <strong>Creation Time:</strong>{" "}
        {new Date(label.creation_time).toLocaleString()}
      </p>
      <p>
        <strong>Updated Time:</strong>{" "}
        {new Date(label.updated_time).toLocaleString()}
      </p>
      <div className="segm-anno-label-detail-actions">
        <Link to={`/segm_anno_labels/${id}/edit`}>
          <button>Edit</button>
        </Link>
        <Link to={`/${label.foreign_key.modality}s/${label.foreign_key.id}`}>
          <button>View {label.foreign_key.modality.toUpperCase()}</button>
        </Link>
        <button onClick={handleDelete}>Delete</button>
      </div>
    </div>
  );
};

export default SegmAnnoLabelDetail;
